/**
 * 固有特性（企画書 §9.4）。
 *
 * AI に自由文で能力を作らせない、という設計の中核。企画書 §9.4 の指定は明確で、
 *
 *   AI解析 → trait_id を選択 → ゲームエンジンが定義済み効果を適用
 *
 * という流れにする。AI が「炎を纏い敵を焼き尽くす」のような文章を生成し、それをゲームが
 * 解釈する設計にはしない。理由は 3 つあり、(1) 効果がバランス調整不能になる、
 * (2) 同じ絵で再鑑定するたびに強さが変わる（§20 の不正対策と衝突する）、
 * (3) 戦闘の再現性が AI モデルのバージョンに依存してしまう（§10.3 と衝突する）。
 *
 * よって AI の役割は「このマスターの中から選ぶ」ことに限定される。
 */
export const TRAIT_IDS = [
    'light_weight',
    'heavy_armor',
    'flame_body',
    'flight',
    'regeneration',
    'afterimage',
    'adversity',
    'one_hit_kill',
];
/**
 * 特性マスター。企画書 §9.4 の例を初期セットとする。
 *
 * ここにあるのは ID・表示名・説明文だけで、**効果の実装は含まない**。
 * 効果は `@drawgon/game-engine` が `TraitId` から解決する。このパッケージは全クライアントが
 * 読み込むため、戦闘ロジックを持ち込むとモバイルのバンドルにエンジンが入ってしまう。
 */
export const TRAITS = {
    light_weight: {
        id: 'light_weight',
        implemented: true,
        name: '軽量',
        description: '素早さが上がりやすい',
    },
    heavy_armor: {
        id: 'heavy_armor',
        implemented: true,
        name: '重装',
        description: '被ダメージを軽減する',
    },
    flame_body: {
        id: 'flame_body',
        implemented: true,
        name: '炎の身体',
        description: '接触した相手を燃やす',
    },
    flight: { id: 'flight', implemented: true, name: '飛行', description: '一部の攻撃を回避する' },
    regeneration: {
        id: 'regeneration',
        name: '再生',
        description: 'ターン経過で HP が回復する',
        implemented: true,
    },
    afterimage: { id: 'afterimage', implemented: true, name: '残像', description: '回避率が上がる' },
    adversity: {
        id: 'adversity',
        implemented: true,
        name: '逆境',
        description: 'HP が低いほど攻撃力が上がる',
    },
    one_hit_kill: {
        id: 'one_hit_kill',
        name: '一撃必殺型',
        description: '低確率で大ダメージを与える',
        implemented: true,
    },
};
